import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import format from "date-fns/format";
import ru from "date-fns/locale/ru";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { getOrganizationNames } from "sources/admin";
import RecommendationForm from "./form";

export class OrganizationRecommendationsList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID",
                accessor: "id",
                width: 100,
                filterable: true,
                filterType: "int",
            },
            {
                Header: "Компания",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ value, row: { original } }) => (
                    <Link to={paths.adminOrganizationsShow(original.organizationId)}>{value}</Link>
                ),
            },
            {
                Header: "Месяц",
                accessor: "month",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => format(new Date(value), "LLLL, yyyy", { locale: ru }),
                CSVExport: ({ value }) => format(new Date(value), "LLLL, yyyy", { locale: ru }),
            },
            {
                Header: "Дата обновления",
                accessor: "updatedAt",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Пользователь",
                accessor: "userDisplayName",
            },
            {
                Header: "Файл",
                accessor: "file",
                Cell: ({ value }) => (
                    <a target="_blank" rel="noopener noreferrer" href={value.accessUrlLink}>
                        {value.originalFileName}
                    </a>
                ),
                CSVExport: ({ value }) => value,
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "default",
                title: "Создание рекомендации",
                windowMod: "wide",
                CustomBody: RecommendationForm,
                bodyData: {
                    mergeParams,
                },
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Добавить рекомендацию
            </a>
        );
    };
}

export default tableContainer(OrganizationRecommendationsList, "organization-recommendations");
